import { NgForOf, NgIf, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit }                      from '@angular/core';
import { FormBuilder, ReactiveFormsModule }                                from '@angular/forms';
import { MatCheckboxModule }      from '@angular/material/checkbox';
import { LetDirective, PushPipe } from '@ngrx/component';
import { Store }                  from '@ngrx/store';
import { ITarificationState } from 'src/app/shared/ngrx/store/state/tarification/tarification.state';
import { CheckEligiblePipe }                                               from 'src/app/shared/pipe/checkEligible.pipe';
import { PricePrecoPipe }     from 'src/app/shared/pipe/price-preco.pipe';
import { AbstractPrecoOavComponent }                                       from '../abstractPreco-oav.component';

@Component ({
              selector:        'app-preco-default',
              templateUrl:     './preco-default.component.html',
              styleUrls:       ['./preco-default.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports: [
                ReactiveFormsModule,
                NgStyle,
                PushPipe,
                NgForOf,
                NgSwitchCase,
                NgSwitchDefault,
                NgIf,
                MatCheckboxModule,
                NgSwitch,
                PricePrecoPipe,
                LetDirective,
                CheckEligiblePipe,
              ],
              providers:       [],
            })
export class PrecoDefaultComponent extends AbstractPrecoOavComponent implements OnInit {
  constructor (protected override _fb: FormBuilder, protected override _store: Store<ITarificationState>) {
    super (_fb, _store);
  }

  override ngOnInit (): void {
    super.ngOnInit ();
  }
}
